import { useEffect, useState } from 'react'
import Login from './components/Login'
import MapView from './components/Map'
import LayerControl, { type LayerKey, type BasemapKey } from './components/LayerControl'

export default function App() {
  const [authed, setAuthed] = useState<boolean | null>(null)
  const [activeLayers, setActiveLayers] = useState<Set<LayerKey>>(
    new Set(['point_limite', 'parcelle']),
  )
  const [basemap, setBasemap] = useState<BasemapKey>('osm')
  const [showLabels, setShowLabels] = useState(true)
  const [drawerOpen, setDrawerOpen] = useState(false)

  useEffect(() => {
    fetch('/api/auth/me', { credentials: 'include' })
      .then((r) => setAuthed(r.ok))
      .catch(() => setAuthed(false))
  }, [])

  const toggleLayer = (key: LayerKey) => {
    setActiveLayers((prev) => {
      const next = new Set(prev)
      next.has(key) ? next.delete(key) : next.add(key)
      return next
    })
  }

  const logout = async () => {
    await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
    setAuthed(false)
  }

  if (authed === null) {
    return (
      <div className="login">
        <div className="login-box">Chargement…</div>
      </div>
    )
  }

  if (!authed) {
    return <Login onSuccess={() => setAuthed(true)} />
  }

  return (
    <div className="app">
      <header className="header">
        <button
          className="hamburger"
          onClick={() => setDrawerOpen((v) => !v)}
          aria-label="Menu des couches"
        >
          ☰
        </button>
        <h1>
          <span className="header-full">Map SITG — Mensuration officielle</span>
          <span className="header-short">Map SITG</span>
        </h1>
        <button onClick={logout} className="logout-btn">
          Déconnexion
        </button>
      </header>
      <div className="body">
        {drawerOpen && (
          <div className="drawer-backdrop" onClick={() => setDrawerOpen(false)} />
        )}
        <aside className={`sidebar ${drawerOpen ? 'open' : ''}`}>
          <LayerControl
            active={activeLayers}
            onToggle={toggleLayer}
            basemap={basemap}
            onBasemapChange={setBasemap}
            showLabels={showLabels}
            onToggleLabels={setShowLabels}
          />
        </aside>
        <main className="map-container">
          <MapView
            activeLayers={activeLayers}
            basemap={basemap}
            showLabels={showLabels}
          />
        </main>
      </div>
    </div>
  )
}
